import React, { useEffect, useState } from "react";
import {
  getLeadStages,
  createLeadStage,
  updateLeadStage,
  deleteLeadStage,
} from "../api";

export default function LeadStages() {
  const [stages, setStages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [stageName, setStageName] = useState("");
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    loadStages();
  }, []);

  async function loadStages() {
    try {
      const res = await getLeadStages();
      setStages(res.data);
    } catch (err) {
      console.log(err);
    }
  }

  async function saveStage() {
    if (!stageName.trim()) return;

    try {
      if (editingId) {
        await updateLeadStage(editingId, stageName);
      } else {
        await createLeadStage(stageName);
      }

      await loadStages();

      setStageName("");
      setEditingId(null);
      setShowModal(false);
    } catch (err) {
      console.log(err);
    }
  }

  async function removeStage(id) {
    if (!window.confirm("Delete this stage?")) return;

    try {
      await deleteLeadStage(id);
      await loadStages();
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div style={{ padding: "30px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2>Lead Stages</h2>

        <button
          onClick={() => {
            setEditingId(null);
            setStageName("");
            setShowModal(true);
          }}
          style={{
    padding: "10px 20px",
    background: "#16a34a",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: 600,
}}
        >
          + Add Stage
        </button>
      </div>

      <table
  border="1"
  cellPadding="16"
  style={{
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  }}
>
        <thead>
          <tr>
            <th>ID</th>
            <th>Stage</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>

        <tbody>
          {stages.map((stage) => (
            <tr key={stage.id}>
              <td>{stage.id}</td>

              <td>{stage.display_name}</td>

              <td>
                <button
  onClick={() => {
    setEditingId(stage.id);
    setStageName(stage.display_name);
    setShowModal(true);
  }}
  style={{
    background: "#2563eb",
    color: "#fff",
    border: "none",
    padding: "8px 18px",
    borderRadius: "8px",
    cursor: "pointer",
  }}
>
  Edit
</button>
              </td>

              <td>
                <button
  onClick={() => removeStage(stage.id)}
  style={{
    background: "#dc2626",
    color: "#fff",
    border: "none",
    padding: "8px 18px",
    borderRadius: "8px",
    cursor: "pointer",
  }}
>
  Delete
</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.35)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: 400,
              background: "#fff",
              padding: 25,
              borderRadius: 10,
            }}
          >
            <h3>
              {editingId ? "Edit Lead Stage" : "Add Lead Stage"}
            </h3>

            <input
              value={stageName}
              onChange={(e) => setStageName(e.target.value)}
              placeholder="Stage Name"
              style={{
                width: "100%",
                padding: 10,
                marginTop: 15,
                marginBottom: 20,
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
              }}
            >
              <button
                onClick={() => {
                  setShowModal(false);
                  setEditingId(null);
                  setStageName("");
                }}
              >
                Cancel
              </button>

              <button
                onClick={saveStage}
                style={{
    background: "#16a34a",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    cursor: "pointer",
}}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}